import DeudasListView from './views/DeudasListView'
import DeudaCreateView from './views/DeudaCreateView'
import DeudaView from './views/DeudaView'

export default [
  {
    path: '/deudas',
    name: 'deudasEntreClubes',
    component: DeudasListView
  },
  {
    path: '/deuda/:id',
    name: 'detalleDeuda',
    component: DeudaView
  },
  {
    path: '/deuda-nueva',
    name: 'deudaNueva',
    component: DeudaCreateView
  }
]
